// Klaviyo signup form handler
(function () {
  var KLAVIYO_API_KEY = 'Ye6GmM';
  var KLAVIYO_LIST_ID = 'TzxkR6';

  function submitToKlaviyo(email, firstName, successId, errorId, formEl) {
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_API_KEY, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: Object.assign(
                  { email: email },
                  firstName ? { first_name: firstName } : {}
                )
              }
            },
            custom_source: 'Theme signup'
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
        }
      })
    })
    .then(function (res) {
      if (res.ok || res.status === 202) {
        var s = document.getElementById(successId);
        if (s) s.style.display = 'block';
        if (formEl) formEl.reset();
      } else {
        var e = document.getElementById(errorId);
        if (e) { e.textContent = 'Something went wrong. Please try again.'; e.style.display = 'block'; }
      }
    })
    .catch(function (err) {
      var e = document.getElementById(errorId);
      if (e) { e.textContent = 'Error: ' + err.message; e.style.display = 'block'; }
    });
  }

  function init() {
    // Footer form
    var footerBtn = document.getElementById('footer-submit');
    var footerForm = document.getElementById('footer-klaviyo-form');
    if (footerBtn && footerForm) {
      footerBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var email = footerForm.querySelector('[name="email"]').value;
        var firstName = footerForm.querySelector('[name="first_name"]') ? footerForm.querySelector('[name="first_name"]').value : '';
        if (!email) return;
        submitToKlaviyo(email, firstName, 'footer-signup-success', 'footer-signup-error', footerForm);
      });
    }

    // Newsletter section form
    var nlBtn = document.getElementById('newsletter-submit');
    var nlForm = document.getElementById('newsletter-form-klaviyo');
    if (nlBtn && nlForm) {
      nlBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var email = nlForm.querySelector('[name="email"]').value;
        if (!email) return;
        submitToKlaviyo(email, '', 'newsletter-success', 'newsletter-error', nlForm);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
